import { Injectable, inject } from '@angular/core'
import { Router } from '@angular/router'
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject'
import { catchError, take, tap } from 'rxjs'
import { toSignal } from "@angular/core/rxjs-interop"

import {  DepartmentDTO, DepartmentGetAllDTO } from '../interfaces'
import { APIRequestResources, PaginationResponse } from "../core"
import { ApiService } from '../core'

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  private readonly apiService = inject(ApiService)
  private readonly router = inject(Router)

  private readonly $all = new BehaviorSubject<DepartmentGetAllDTO[]>([])
  all = toSignal(this.$all, { initialValue: [] })

  constructor() {
    // this.getAll().pipe(take(1)).subscribe()
  }

  getAll = (refresh = false) => {
    return this.apiService.GET<DepartmentGetAllDTO[]>(
        APIRequestResources.DepartmentService,
        {},
        true,
        refresh,
    ).pipe(
        tap((res) => this.$all.next(res.data))
    )
  }

  find = (params: any, refresh = false) => {
    return this.apiService.GET<PaginationResponse<DepartmentDTO[]>>(
        APIRequestResources.DepartmentService,
        {
          endpoint: `find`,
          params: params
        },
        true,
        refresh,

    ).pipe(take(1))
  }

}